// behavior-view.js

import $ from 'jquery';
import _ from 'lodash';

import { View } from 'backbone';
import contentTemplate from 'properties/behavior-view.ejs';
import objectBehaviorMap from 'ObjectBehaviorMapService';
import listService from 'ListService';
import constants from 'Constants';
import BehaviorHelperService from 'BehaviorHelperService';

class BehaviorView extends View {

    initialize(opts) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#propBeh';
        this.factoryKey = opts.factoryKey;

        if (!this.factoryKey) {
            this.factoryKey = this.model.attributes.factoryKey;
        }

        this.events = {
            'click .behaviorLink': 'handleBehaviourLinkClick'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }


    handleBehaviourLinkClick(ev) {
            BehaviorHelperService.processBehaviorClickEvent(ev, this.factoryKey, this.model)
    }

    close() {
        super.remove();
        this.unbind();
        if (this.onClose) {
            this.onClose();
        }
    }

    // Target control could be one of: form, control, or table column. Return its ID.
    _resolveTargetId( factoryKey, opts ) {

        const
            isColumn = factoryKey && factoryKey.endsWith('Column'),
            colIndex = isColumn ? opts.colId : undefined;

        let thisId = 'Form';
        if(factoryKey !== 'layout_frame' &&  factoryKey !== 'reports_frame'){
            thisId = this.model.get('id');
        }

        if (opts && opts.id) {
            thisId = opts.id;
        }

        // But wait. previous bets are off if target is a column. Here, behaviors associate to a gridData[colIndex] drilldown
        // Thus, thisId would be that of table's clicked column Id
        if (isColumn) {
            const tableView = listService.getObject( this.model.get('id') );
            thisId = tableView.getColumns()[ colIndex ].id;
        }
        return thisId;
    }

    render(opts) {
        this.$el.empty();
        this.factoryKey = this.model.attributes.factoryKey;

        if (opts && opts.factoryKey) {
            this.factoryKey = opts.factoryKey;
        }

        const thisId = this._resolveTargetId( this.factoryKey, opts );

        let behaviors = objectBehaviorMap.getBehaviors(this.factoryKey);

        // PF-4071: When table details are selected, selectedCount is = 0
        //          we are validating this scenario below
        if (behaviors.length > 0 && ( listService.selectedCount === 0 || listService.selectedCount === 1 ) ) {
            _.forEach(behaviors, item => {
                const instance = listService.getBehaviorInstanceByObjectAndBehaviorKey(thisId, item.behaviorKey);
                const object = instance && listService.getBehaviorInstanceObjects(instance.id);
                if (object && object.size > 0){
                    item.active = 'active';
                } else {
                    item.active = '';
                }

            });
        }
        else {
            behaviors = undefined;
        }

        const rootBehaviors = {
            behaviors: behaviors,
            id: thisId,
            isMobile: listService.mainKind === constants.KIND_MOBILE
        };

        this.$el.css('display', behaviors ? '' : 'none');
        this.$el.html(this.template(rootBehaviors));

        if (listService.mainKind === 'W') {
            const views = objectBehaviorMap.getBehaviorViews(this.factoryKey);
            if (views) {
                views.map(v => {
                    var obj = new v.view({ model: this.model, el: $(v.el), config: v.config });
                    obj.render();
                });
            }
        }

        $('#behaviors-section .switch').on('click',function () {
            $(this).find('i').toggleClass('pf-carot-down pf-carot-left');
        });

        this.delegateEvents();
        return this;
    }
}

export default BehaviorView;
